<!-- <demographic></demographic> -->
<div fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    <mat-tab-group style="width: 100%; background: white;padding-bottom: 60px;" (selectedTabChange)="sendBroadcast($event)">
        <mat-tab label="{{'CERTIFICAR.DEMOGRAFICOS.TAB1' | translate}}">
            <demographic [pasoCompleto]="pasoCompleto"></demographic>
        </mat-tab>

        <mat-tab *ngIf="numArrayTraduc > 0" label="{{'CERTIFICAR.DEMOGRAFICOS.TAB2' | translate}}">
            <demo-translate [pasoCompleto]="pasoCompleto"></demo-translate>
        </mat-tab>

        <mat-tab label="{{'CERTIFICAR.DEMOGRAFICOS.TAB3' | translate}}">
            <demo-preview></demo-preview>
        </mat-tab>
    </mat-tab-group>
    <!-----------boton finalizar paso---------->
    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'CERTIFICAR.DEMOGRAFICOS.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
      <mat-icon>done</mat-icon>
    </button>
        <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.DEMOGRAFICOS.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>

    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearDemograficos()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.DEMOGRAFICOS.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearDemograficos()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.DEMOGRAFICOS.STATUS.UNLOCK' | translate}}
      <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
    </button>
    </div>
</div>

<!-- <fuse-demo-content></fuse-demo-content> -->
